import { call, put } from 'redux-saga/effects'

import req from '@sportninja/common/api/request'
import { resolveEntityRoles } from '@sportninja/common/ts-utils/entity-roles'

const _read = (entityType) => async (id) => await req(`/${entityType}/${id}`)

export const readFactory = (entityType, action) =>
  function* (payload) {
    const { id } = payload
    const { data, meta } = yield call(_read(entityType), id)

    // Include permissions object if present
    let permission
    if (meta && meta.permissions) permission = meta.permissions[id]

    // The viewer's own role(s) on this entity, resolved the same way as the
    // permission flags above — the read carries the answer with it.
    const roles = resolveEntityRoles(meta && meta.roles, id)

    let hierarchy
    if (meta && meta.hierarchy) hierarchy = meta.hierarchy

    const mergedData = { ...data, permission, roles, hierarchy }
    yield put(action.success({ id, data: mergedData }))
    return data
  }

export const readWithPagesFactory = (method, action) =>
  function* (payload) {
    const {
      id,
      page,
      sort,
      direction,
      is_archive,
      competition_type,
      sport_id,
      generic_sport_id,
    } = payload
    const response =
      typeof id === 'string'
        ? yield call(
            method,
            id,
            page,
            sort,
            direction,
            is_archive,
            competition_type,
            sport_id,
            generic_sport_id
          )
        : yield call(
            method,
            page,
            sort,
            direction,
            is_archive,
            competition_type,
            sport_id,
            generic_sport_id
          )
    const { data, meta } = response

    // Combine in the permission for each item in the list
    yield put(
      action.success({
        id,
        data: data.map((d) => {
          let permission

          if (meta && meta.permissions && meta.permissions[d.id]) {
            permission = meta.permissions[d.id]
          }

          return {
            ...d,
            permission,
          }
        }),
      })
    )
    return response
  }
